import { useMsal } from "@azure/msal-react";
import {
    DefaultButton,
    Dropdown,
    IColumn,
    IDropdownOption,
    IPanelProps,
    IRenderFunction,
    Panel,
    PanelType, PrimaryButton,
    SelectionMode, Separator, Spinner, Stack,
    Text
} from "@fluentui/react";
import { RootState } from "app/store";
import { DefaultGridConfig } from "components/controls/CustomDetailList/CustomDetailList";
import { IGridItem } from "components/controls/CustomDetailList/IGridItem";
import { emitCustomEvent, panelButtonsStyles } from "global/Application";
import { useMemo, useState } from "react";
import { ConnectedProps, connect, useSelector } from "react-redux";
import { AppDataSource } from "../../global/DataSources/AppDataSource";
import { MsalTokenSource } from "../../global/DataSources/MsalTokenSource";
import {
    IPlan as FAM_IPlan
} from "../../model/FlexibleAttributeModel";
import PlanGrid from "./Controls/PlanGrid";
import saveAs from "file-saver";

interface IProps extends TComponentConnectedProps {
    isOpen: boolean;

    // cancellation of transaction/partial actions
    onCancel?: () => void;

    // dialog closure request from parent component
    onDismiss: () => void

}


interface IItem extends IGridItem<FAM_IPlan> {
}

const BenefitSummaryReportWizard = (props: IProps) => {

    const [loading, setLoading] = useState<boolean>(false);
    const { instance } = useMsal();

    const tokenSource = new MsalTokenSource(instance);
    const dataSource = new AppDataSource(tokenSource);

    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    const state = useSelector((state: RootState) => state);

    const data = useMemo(() => {

        const columns: IColumn[] = [];
        const items = [] as IItem[];

        const data = {
            items, columns,
        }

        if (!props.isOpen)
            return {
                items,
                columns,
            };

        columns.push({
            key: 'plan',
            fieldName: 'plan',
            name: 'Plan',
            minWidth: 250,
            isResizable: true,
        });


        state.data.json.plans.forEach((plan, i) => {
            items.push({
                key: plan.id,
                _index: i,
                plan: plan.name,
                data: plan,
            });
        });

        return data;

    }, [props.isOpen]);

    const storageId = `benefitsummaryreport.plan.grid`;

    const scopeGridConfig = () => {
        const u = state.status.gridConfigs[storageId];
        if (u)
            return u;

        const t = DefaultGridConfig();
        t.pageSize = -1;
        // t.sort = [{ column: { key: 'attributeSetName' }, isSortedDescending: false }];

        return t;
    }


    // const selection = useMemo(() => {
    //     const selection = new Selection({
    //         onSelectionChanged: () => {

    //         },
    //         selectionMode: SelectionMode.multiple,
    //         items: data.items as any,
    //     });
    //     selection.setIndexSelected(1, true, true);
    //     // return selection;
    // }, [data]);

    const [selectedPlans, setSelectedPlans] = useState<FAM_IPlan[]>([]);

    const options: IDropdownOption[] = useMemo(() => {
        const options = [
            { key: 'medical benefit summary report', text: 'Medical Benefit Summary Report' },
            { key: 'dental benefit summary report', text: 'Dental Benefit Summary Report' },
        ];
        return options;

    }, []);


    const onRenderBody: IRenderFunction<IPanelProps> = (bodyProps, defaultRender) => {
        if (!props.isOpen)
            return <></>;

        return <Stack tokens={{ childrenGap: '10' }}>
            <Separator />

            <Dropdown
                placeholder="Template"
                label="Template"
                options={options}
                selectedKey={options[0].key}
                disabled
            />


            {/* <Stack.Item>
                <SearchBox
                    onSearch={(newValue) => {
                        // setSearch(newValue);
                    }}
                />
            </Stack.Item> */}
            <Stack>
                <Text>Please select the records to include:</Text>
                <PlanGrid
                    disableRefNavigation={true}
                    selectionMode={SelectionMode.multiple}
                    defaultGridConfig={scopeGridConfig()}
                    onChange={(selected) => {
                        setSelectedPlans(selected);
                    }}
                />
            </Stack>
            {/* <DetailsList
                items={data.items}
                columns={data.columns}
                onShouldVirtualize={(props) => false}
                selectionPreservedOnEmptyClick={true}
                layoutMode={DetailsListLayoutMode.justified}
                // selection={selection}
                groupProps={{
                    showEmptyGroups: true,
                }}
            /> */}

        </Stack>;
    }

    // const aggLastString: TGroupByAggregateMethod<IItem> = (prev, current, key, row) => {
    //     return current;
    // };

    const onRenderFooterContent: IRenderFunction<IPanelProps> = (footerProps, defaultRender) => {
        return <div>
            <PrimaryButton text={loading ? 'Generating...' : 'Continue'}
                styles={panelButtonsStyles}
                disabled={loading || selectedPlans.length < 1}
                onClick={async () => {
                    try {
                        setLoading(true);

                        var response = await dataSource.getBenefitSummaryReport(
                            null,
                            {
                                bcbs_groupconfigurationsnapshot: props.state.data.snapshot,
                                plans: selectedPlans,
                            },
                            undefined,
                            state.status.debug.diagnosis,
                        );

                        saveAs(response.blob, response.fileName);

                    } catch (error: any) {
                        emitCustomEvent({
                            eventType: 'globalException',
                            details: error
                        });
                    }
                    finally {
                        setLoading(false);
                    }
                }}
            >
                {loading && <Spinner />}
            </PrimaryButton>
            <DefaultButton text='Cancel' onClick={() => {
                setErrorMessage(null);
                props.onCancel?.();
            }} />
        </div>
    }


    let headerText = "Benefit Summary Report Wizard";

    return <Panel
        isOpen={props.isOpen}
        onDismiss={props.onDismiss}
        type={PanelType.medium}
        headerText={headerText}
        onRenderFooterContent={onRenderFooterContent}
        isFooterAtBottom={true}
    >
        {onRenderBody()}
    </Panel>;
}

function mapStateToProps(state: RootState) { return { state } }
const connector = connect(mapStateToProps);
type TComponentConnectedProps = ConnectedProps<typeof connector>;
export default connect(mapStateToProps)(BenefitSummaryReportWizard)

